import { memo } from "react";
import { ViewportPortal } from "@xyflow/react";
import type { Junction } from "../edges/junctions.ts";

const JUNCTION_RADIUS = 3;

type Props = {
  junctions: Junction[];
};

// Renderar fyllda SVG-cirklar i flow-koordinater via ViewportPortal — då följer
// punkterna pan/zoom automatiskt utan att vi behöver läsa transform själva.
function JunctionsLayerImpl({ junctions }: Props) {
  if (junctions.length === 0) return null;
  return (
    <ViewportPortal>
      <svg
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          overflow: "visible",
          pointerEvents: "none",
        }}
      >
        {junctions.map((j) => (
          <circle
            key={`${j.x}:${j.y}`}
            cx={j.x}
            cy={j.y}
            r={JUNCTION_RADIUS}
            fill="var(--color-fg, #111827)"
          />
        ))}
      </svg>
    </ViewportPortal>
  );
}

export const JunctionsLayer = memo(JunctionsLayerImpl);
JunctionsLayer.displayName = "JunctionsLayer";
